import React from "react";
import "./PresentationStyles.css";
import Navbar from "../../components/modules/Navbar";
import Footer from "../../components/modules/Footer";

import { Link } from "react-router-dom";
import ScrollText from "../../components/ScrollText";

import { motion } from "framer-motion";

import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { useEffect, useState, useRef } from "react";

import Images from "../../components/function/ImagesCaroussel";

import CountUp from "react-countup";
import { IoBookmarksOutline } from "react-icons/io5";
import { AiOutlineArrowRight } from "react-icons/ai";
import affiche from "../../assets/affiche/affiche2026.png";
import { useTranslation } from "react-i18next";
import Qualité from "../../assets/pdf/Politique_qualité_TOSS_2024.pdf";


gsap.registerPlugin(ScrollTrigger);

const Presentation = () => {
  const { t } = useTranslation("common");
  //Animation on scroll
  const FadeBottom = (elem, time) => {
    gsap.fromTo(
      elem,

      {
        y: 100,
        opacity: 0,
      },
      {
        opacity: 1,
        y: 0,

        duration: 0.8,
        delay: time,
        scrollTrigger: {
          trigger: elem,
          start: "-50% 80%",
          end: "bottom center",

          onEnter: setCounterOn(true),
          toggleActions: "play none none none",
        },
      }
    );
  };

  useEffect(() => {
    FadeBottom("#presentation-numbers1", 0);
    FadeBottom("#presentation-numbers2", 0.2);
    FadeBottom("#presentation-numbers3", 0.4);
    FadeBottom("#affiche", 0.4);
  }, []);

  const [widthWrap, setWidthWrap] = useState(0);
  const carousel = useRef();

  useEffect(() => {
    setWidthWrap(carousel.current.scrollWidth - carousel.current.offsetWidth);
  }, []);

  const [counterOn, setCounterOn] = useState(false);

  return (
    <div>
      <Navbar scroll="true" color="transparent" />
      <ScrollText />
      <div className="presentation-edition">
        <h2> {t("presentation_edition.la_33_eme_titre")}</h2>
        <div className="presentation-affiche" id="affiche">
          <img src={affiche} alt="Affiche 2026" />
          <p> crédit: Constance Balansard</p>
        </div>

        <p>{t("presentation_edition.33e_para1")}</p>
        <p>{t("presentation_edition.33e_para2")}</p>
        <p>{t("presentation_edition.33e_para3")}</p>
        <p>{t("presentation_edition.33e_para4")}</p>
      </div>
      <div className="presentation1" id="carousel">
        <div className="presentation-sports">
          <Link to="/sports"> {t("presentation_edition.voir")}</Link>
        </div>
        <motion.div ref={carousel} className="carousel">
          <motion.div
            drag="x"
            dragConstraints={{ right: 0, left: -widthWrap }}
            className="inner-carousel"
          >
            {Images.map((image, index) => {
              return (
                <motion.div key={index} className="item">
                  <img src={image.src} alt="" />
                  <p> {t(`presentation_edition.${image.title}`)}</p>
                </motion.div>
              );
            })}
          </motion.div>
        </motion.div>

        <div className="presentation-team" id="presentation-team">
          <h2> BDS CentraleSupélec</h2>
          <div className="presentation-image"></div>
          <div className="presentation-numbers">
            <div id="presentation-numbers1">
              <h6> {t("presentation_edition.créé")}</h6>
              <h4>
                {" "}
                {counterOn && (
                  <CountUp
                    start={0}
                    end={1989}
                    duration={2}
                    delay={0}
                  ></CountUp>
                )}
              </h4>
            </div>
            <div id="presentation-numbers2">
              <h4>
                {" "}
                {counterOn && (
                  <CountUp
                    start={0}
                    end={42}
                    duration={2}
                    delay={0.5}
                  ></CountUp>
                )}
              </h4>
              <p> {t("presentation_edition.membres")}</p>
            </div>
            <div id="presentation-numbers3">
              <h4>
                {" "}
                {counterOn && (
                  <CountUp start={0} end={240} duration={2} delay={1}></CountUp>
                )}
              </h4>
              <p> {t("presentation_edition.béné")}</p>
            </div>
          </div>
          <p> {t("presentation_edition.paragraphe1")}</p>
          <a href="https://cs-sports.fr/BDS/index.php">
            {" "}
            {t("presentation_edition.voir_notre_site")}{" "}
            <AiOutlineArrowRight className="team-arrow" />
          </a>
        </div>
        <div className="presentation-amelioration">
          <h2> {t("presentation_edition.une_amé")} </h2>
          <div className="presentation-amelioration-content">
            <p> {t("presentation_edition.paragraphe2")}</p>
            <a href={Qualité} target="_blank" rel="noopener noreferrer">
              <IoBookmarksOutline className="book" />{" "}
              {t("presentation_edition.Notre")}
            </a>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Presentation;
